const isProduction = true; 

export const API_BASE_URL = isProduction
  ? 'https://grupo.us.es/ligaincom'
  : 'http://localhost/ligaincom';